<template>
  <v-skeleton-loader
    class="mx-auto"
    :loading="status === 'loading'"
    :type="type"
    transition="fade-transition">
    <slot></slot>
  </v-skeleton-loader>
</template>

<script>
import { mapFields } from 'vuex-map-fields';


export default {
  props: ['type'],
  name: 'SkeletalLoader',
  computed: {
    ...mapFields(['status']),
  },
};
</script>
